// src/reducers/inbox/conversationsListCursor.js
import ActionType from 'actions/ActionType'
import { omit } from 'lodash'

const endpoints = [
  'all',
  'recent/followup',
  'recent/all',
  'recent/in',
  'recent/out',
  'recent/out_r',
  'needsfollowup',
]

const generateInitialState = () => {
  return endpoints.reduce((acc, endpoint) => {
    acc[endpoint] = {
      cursor: '',
      loading: false,
      loadingAll: false,
      emptyPage: false,
      data: {},
    }
    return acc
  }, {})
}

export default (state = generateInitialState(), action) => {
  const switchObj = {
    [ActionType.Inbox.LIST_REQUEST]: () => {
      const endpoint = action.endpoint
      return {
        ...state,
        [endpoint]: {
          ...state[endpoint],
          loading: true,
        },
      }
    },
    [ActionType.Inbox.LIST_SUCCESS]: () => {
      const endpoint = action.endpoint
      return {
        ...state,
        [endpoint]: {
          ...state[endpoint],
          loading: false,
          cursor: action?.cursor || '',
          emptyPage: action.cursor && !action.payload?.length,
          data:
            !endpoint || endpoint === 'all'
              ? null
              : action.payload?.reduce((acc, el) => {
                  acc[el?.contact_id] = el
                  return acc
                }, {}),
        },
      }
    },
    'Inbox.SET_LOADING_ALL': () => {
      const endpoint = action.endpoint
      return {
        ...state,
        [endpoint]: {
          ...state[endpoint],
          loadingAll: action.payload,
        },
      }
    },
    'Inbox.SET_EMPTY_PAGE': () => {
      const endpoint = action.endpoint
      return {
        ...state,
        [endpoint]: {
          ...state[endpoint],
          emptyPage: action.payload,
        },
      }
    },
    'Inbox.SET_CURSOR': () => {
      const endpoint = action.endpoint
      return {
        ...state,
        [endpoint]: {
          ...state[endpoint],
          cursor: action.payload,
        },
      }
    },
    'Inbox.SET_NEEDS_FOLLOW_UP': () => {
      return {
        ...state,
        needsfollowup: {
          ...state.needsfollowup,
          data: { ...state.needsfollowup.data, [action.payload]: true },
        },
      }
    },
    'Inbox.CLEAR_NEEDS_FOLLOW_UP': () => {
      return {
        ...state,
        'recent/followup': {
          ...state['recent/followup'],
          data: omit(state['recent/followup'].data, action.payload),
        },
        needsfollowup: {
          ...state['needsfollowup'],
          data: omit(state['needsfollowup'].data, action.payload),
          // data: {
          //   ...state['needsfollowup'].data,
          //   [action.payload]: false,
          // },
        },
      }
    },
    'Inbox.CLEAR_RECENT_VIEWABLE': () => {
      return {
        ...state,
        'recent/all': {
          ...state['recent/all'],
          data: omit(state['recent/all'].data, action.payload),
        },
        'recent/in': {
          ...state['recent/in'],
          data: omit(state['recent/in'].data, action.payload),
        },
        'recent/out': {
          ...state['recent/out'],
          data: omit(state['recent/out'].data, action.payload),
        },
      }
    },
    [ActionType.Data.DELETE_SUCCESS]: () => {
      if (action.entityType === 'inbox') {
        return {
          ...state,
          // all: {
          //   ...state['all'],
          //   data: omit(state['all'].data, action.id),
          // },
          'recent/followup': {
            ...state['recent/followup'],
            data: omit(state['recent/followup'].data, action.id),
          },
          needsfollowup: {
            ...state['needsfollowup'],
            data: omit(state['needsfollowup'].data, action.id),
          },
          'recent/out': {
            ...state['recent/out'],
            data: omit(state['recent/out'].data, action.id),
          },
          'recent/all': {
            ...state['recent/all'],
            data: omit(state['recent/all'].data, action.id),
          },
          'recent/in': {
            ...state['recent/in'],
            data: omit(state['recent/in'].data, action.id),
          },
          'recent/out_r': {
            ...state['recent/out_r'],
            data: omit(state['recent/out_r'].data, action.id),
          },
        }
      }
      return state
    },
    [ActionType.Inbox.FILTER_CONVERSATIONS_LIST]: () => {
      return {
        ...state,
        [action.payload]: {
          ...(state[action.payload] || {}),
          loading: true,
        },
      }
    },
    // [ActionType.Inbox.FILTER_USER_CONVERSATIONS_LIST]: () => {
    //   const endpoint = action.payload
    //   return {
    //     ...state,
    //     [endpoint]: {
    //       ...state[endpoint],
    //       cursor: '',
    //       loading: true,
    //     },
    //   }
    // },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
